(function () {
    var activeController = null;

    function getDrawer() {
        return document.getElementById('zpro-quickview');
    }

    function getContentEl() {
        var drawer = getDrawer();
        return drawer ? drawer.querySelector('[data-quickview-content]') : null;
    }

    function ensureQuickViewUrl(href) {
        if (!href) {
            return '';
        }
        try {
            var url = new URL(href, window.location.origin);
            if (!url.searchParams.has('view')) {
                url.searchParams.set('view', 'quickview');
            }
            return url.toString();
        } catch (err) {
            if (href.indexOf('view=quickview') !== -1) {
                return href;
            }
            return href + (href.indexOf('?') >= 0 ? '&' : '?') + 'view=quickview';
        }
    }

    function closeMiniCart() {
        if (
            typeof PROJ !== 'undefined' &&
            PROJ.ajaxcart &&
            typeof PROJ.ajaxcart.closecart === 'function'
        ) {
            PROJ.ajaxcart.closecart();
        }
    }

    function openDrawer() {
        document.documentElement.classList.add('fs-quickview-open');
        document.body.classList.add('fs-quickview-open');
        var drawer = getDrawer();
        if (drawer) {
            drawer.setAttribute('aria-hidden', 'false');
        }
    }

    function closeDrawer() {
        if (activeController) {
            activeController.abort();
            activeController = null;
        }
        document.documentElement.classList.remove('fs-quickview-open');
        document.body.classList.remove('fs-quickview-open');
        var drawer = getDrawer();
        if (drawer) {
            drawer.setAttribute('aria-hidden', 'true');
            var content = getContentEl();
            if (content) {
                content.innerHTML = '';
            }
        }
    }

    function resizePdpGallery(instances) {
        if (!instances || !instances.length) {
            return;
        }
        instances.forEach(function (flk) {
            if (flk && typeof flk.resize === 'function') {
                flk.resize();
            }
        });
    }

    function initPdpGallery(root) {
        if (!root || typeof Flickity === 'undefined') {
            return;
        }
        var mainv = root.querySelector('.fs-main-gal');
        if (!mainv || mainv.classList.contains('flickity-enabled')) {
            return;
        }
        var instances = [];
        var mainFlk = new Flickity(mainv, {
            cellAlign: 'center',
            contain: true,
            adaptiveHeight: true,
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: false
        });
        instances.push(mainFlk);
        var thumbv = root.querySelector('.fs-thumb-gal');
        if (thumbv && !thumbv.classList.contains('flickity-enabled')) {
            instances.push(
                new Flickity(thumbv, {
                    cellAlign: 'center',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: true,
                    asNavFor: mainv
                })
            );
        }

        // Drawer content is measured before layout settles; resize matches window-resize fix.
        resizePdpGallery(instances);
        requestAnimationFrame(function () {
            resizePdpGallery(instances);
            requestAnimationFrame(function () {
                resizePdpGallery(instances);
            });
        });
        // After panel slide-in (0.35s) and any late image layout.
        setTimeout(function () {
            resizePdpGallery(instances);
        }, 400);
    }

    function initPdpForms(root) {
        if (!root || typeof PROJ === 'undefined' || !PROJ.pdp) {
            return;
        }
        root.querySelectorAll('form.fs-product-form').forEach(function (form) {
            if (typeof PROJ.isProductCartForm === 'function' && !PROJ.isProductCartForm(form)) {
                return;
            }
            if (typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
                PROJ.pdp.syncPdpMainAtcMirrors(form);
            }
            if (typeof PROJ.pdp.updateForm === 'function') {
                PROJ.pdp.updateForm(form);
            }
        });
    }

    function shouldHideAtc(href, link) {
        if (link && link.hasAttribute('data-quickview-hide-atc')) {
            return true;
        }
        if (!href) {
            return false;
        }
        try {
            var url = new URL(href, window.location.origin);
            return url.searchParams.get('hide_atc') === '1';
        } catch (err) {
            return href.indexOf('hide_atc=1') !== -1;
        }
    }

    function loadQuickView(href, options) {
        var content = getContentEl();
        if (!content) {
            return;
        }

        options = options || {};
        var hideAtc = !!options.hideAtc;

        if (activeController) {
            activeController.abort();
        }
        activeController = new AbortController();
        var signal = activeController.signal;

        closeMiniCart();
        openDrawer();
        content.innerHTML = '<div class="zpro-quickview__loading">Loading…</div>';

        fetch(href, { credentials: 'same-origin', signal: signal })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('fetch failed');
                }
                return response.text();
            })
            .then(function (html) {
                if (signal.aborted) {
                    return;
                }

                var doc = new DOMParser().parseFromString(html, 'text/html');
                var wrap = doc.querySelector('.pdp-layout-wrap');
                if (!wrap) {
                    content.innerHTML = '<p class="zpro-quickview__error">Unable to load product.</p>';
                    return;
                }

                var productPath =
                    wrap.getAttribute('data-qv-product-path') ||
                    (function () {
                        try {
                            return new URL(href, window.location.origin).pathname;
                        } catch (e) {
                            return '';
                        }
                    })();

                var root = document.createElement('div');
                root.className = 'st-pdp-layout zpro-quickview__pdp';
                if (productPath) {
                    root.setAttribute('data-qv-product-path', productPath);
                }
                if (hideAtc) {
                    root.setAttribute('data-quickview-hide-atc', 'true');
                }
                root.innerHTML = wrap.outerHTML;

                content.innerHTML = '';
                content.appendChild(root);

                initPdpGallery(root);
                if (!hideAtc) {
                    initPdpForms(root);
                }
                if (
                    typeof PROJ !== 'undefined' &&
                    PROJ.pdp &&
                    typeof PROJ.pdp.syncDetailDropdownPanels === 'function'
                ) {
                    PROJ.pdp.syncDetailDropdownPanels(root);
                }
            })
            .catch(function (err) {
                if (err && err.name === 'AbortError') {
                    return;
                }
                if (!signal.aborted && getContentEl()) {
                    getContentEl().innerHTML =
                        '<p class="zpro-quickview__error">Unable to load product. Please try again.</p>';
                }
            });
    }

    document.body.addEventListener('click', function (e) {
        var link = e.target.closest('a.jspc-pdlink');
        if (!link || link.target === '_blank') {
            return;
        }
        e.preventDefault();
        var href = ensureQuickViewUrl(link.getAttribute('href'));
        if (href) {
            loadQuickView(href, { hideAtc: shouldHideAtc(href, link) });
        }
    });

    // Group / size option cards in the drawer (not inline variants) — stay in popup instead of full page nav.
    document.body.addEventListener('click', function (e) {
        var card = e.target.closest('[data-quickview-content] a.pdp-option-card');
        if (!card || card.target === '_blank') {
            return;
        }
        // Same-product variants use data-pdp-inline-variant (handled in fs-theme.js).
        if (card.hasAttribute('data-pdp-inline-variant')) {
            return;
        }
        var hrefAttr = card.getAttribute('href');
        if (!hrefAttr || hrefAttr === '#') {
            return;
        }
        e.preventDefault();
        var href = ensureQuickViewUrl(hrefAttr);
        var qvRoot = card.closest('.zpro-quickview__pdp');
        var hideAtc = !!(qvRoot && qvRoot.hasAttribute('data-quickview-hide-atc'));
        if (href) {
            loadQuickView(href, { hideAtc: hideAtc });
        }
    });

    document.body.addEventListener('click', function (e) {
        if (e.target.closest('[data-quickview-close]')) {
            e.preventDefault();
            closeDrawer();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && document.body.classList.contains('fs-quickview-open')) {
            closeDrawer();
        }
    });

    window.PROJ = window.PROJ || {};
    PROJ.quickview = {
        open: loadQuickView,
        close: closeDrawer
    };
})();
